import api from './client';

export const statsAPI = {
  get: async (params?: { activeDevicesDays?: number }) => {
    const response = await api.get('/api/admin/stats', { params });
    return response.data;
  },
};
